import { Loading as LoadingIcon } from '@linktivity/link-ui';
import cls from 'clsx';

import styles from './loading.module.css';

interface LoadingProps {
  opacity?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ opacity = false }) => {
  return (
    <div className={cls(styles.overlay, { [styles.opacity]: opacity })}>
      <div className={styles.loadingContainer}>
        <LoadingIcon />
      </div>
    </div>
  );
};

export default Loading;
